<template>
  <select v-model="model[name]" :id="name" :name="name" class="form-control">
    <option :value="undefined">{{ firstOption }}</option>
    <option v-for="(opt, index) in list" v-bind:key="index" :value="opt[value]">
      {{ opt[title] }}
    </option>
  </select>
</template>
<script>
import ObjectUtil from '../../utils/ObjectUtil';

export default {
  name: 'SortedSelect',
  props: {
    name: String,
    model: { required: true },
    firstOption: { default: 'Select' },
    listOptions: Array,
    value: { required: true },
    title: { required: true },
  },
  computed: {
    list() {
      return ObjectUtil.sortArrayOfObject(this.listOptions, this.title);
    },
  },
};
</script>
